module.exports = __webpack_public_path__ + "img/Capture.6da2b75b.png";